import SlideFrame from './SlideFrame';
import CopyBtn from '../CopyBtn';

interface AnatItem { t: string; d: string }
interface Example { tag: string; body: string }

interface Props {
  title: string; sub: string;
  anat_t: string; examples_t: string;
  anat: AnatItem[];
  examples: Example[];
}

export default function PromptAnatomy({ title, sub, anat_t, examples_t, anat, examples }: Props) {
  return (
    <SlideFrame title={title} sub={sub}>
      <div className="prompt-split">
        <div>
          <div className="prompt-col-t">{anat_t}</div>
          <div className="prompt-anat">
            {anat.map((item, i) => (
              <div key={i} className="prompt-anat-item">
                <div className="prompt-anat-t">{item.t}</div>
                <div className="prompt-anat-d">{item.d}</div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="prompt-col-t">{examples_t}</div>
          <div className="prompt-examples">
            {examples.map((ex, i) => (
              <div key={i} className="prompt-example prompt-example-wrap">
                <div className="prompt-example-tag">{ex.tag}</div>
                <div className="prompt-example-body">{ex.body}</div>
                <CopyBtn text={ex.body} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </SlideFrame>
  );
}
